/* ==========================================================================
   <flux-galerij> — productfoto's op de productpagina.

   Klik of pijltjes wisselen de grote foto; de knoppen zijn tabs
   (role="tab"), dus schermlezers horen welke foto actief is. Zonder
   JavaScript zie je de hoofdfoto en alle miniaturen: niets verdwijnt.
   ========================================================================== */

(() => {
  /* ---------------------------------------------------- meelopende bestelbalk

     Zichtbaar zodra de gewone koopknop uit beeld is. Prijs en beschikbaarheid
     volgen de variantkeuze: Dawn vervangt bij een wissel de inhoud van
     #price-… en zet de gewone knop op disabled; we kijken mee met een
     MutationObserver in plaats van Dawn's JS aan te passen. */

  function stickyKoopbalk() {
    const balk = document.querySelector('[data-sticky-koop]');
    const knoppen = document.querySelector('[data-koopknoppen]');
    if (!balk || !knoppen) return;

    const knop = balk.querySelector('[data-sticky-knop]');
    const echteKnop = knoppen.querySelector('[id^="ProductSubmitButton-"]');

    // Zichtbaar zodra de prijs bij de titel boven langs de header voorbij is;
    // weg zolang de gewone knop in beeld is (geen twee knoppen tegelijk).
    // Staat de prijs nog onder de schermrand (telefoon: eerst de foto), dan
    // is hij nog niet voorbij. Zonder prijs bij de titel (prijs 0) telt
    // alleen de gewone knop.
    const kopPrijs = document.querySelector('[data-kop-prijs]');
    const header = document.querySelector('.flux-header-section');
    let prijsVoorbij = !kopPrijs;
    let knopInBeeld = false;
    const zicht = () => {
      balk.hidden = !prijsVoorbij || knopInBeeld;
    };
    new IntersectionObserver(
      ([regel]) => {
        knopInBeeld = regel.isIntersecting;
        zicht();
      },
      { rootMargin: '0px 0px -80px 0px' }
    ).observe(knoppen);
    // Bij het scrollen gemeten, één keer per frame. Een IntersectionObserver
    // meldt alleen overgangen, en mist dus een sprong van "nog onder de
    // schermrand" naar "al voorbij" (snelle veeg, herladen halverwege).
    if (kopPrijs) {
      let wacht = 0;
      const meet = () => {
        wacht = 0;
        const onderHeader = header?.getBoundingClientRect().bottom || 0;
        prijsVoorbij = kopPrijs.getBoundingClientRect().bottom < onderHeader;
        zicht();
      };
      window.addEventListener('scroll', () => (wacht ||= requestAnimationFrame(meet)), { passive: true });
      meet();
    }

    // Chatknop en andere zwevende elementen schuiven boven de balk zolang die
    // in beeld is (--zwevend-onder in src/app.css telt --koopbalk-h op): de
    // hoogte van de balk plus 1,2rem tussenruimte. Een ResizeObserver ziet
    // zowel verschijnen en verdwijnen (hoogte 0 bij hidden) als een andere
    // hoogte na draaien of een breakpoint.
    // De chatknop staat naast de balk, op het midden ervan (--chat-onder).
    const chat = document.querySelector('[data-flux-chat]');
    new ResizeObserver(() => {
      const balkHoogte = balk.hidden ? 0 : Math.round(balk.getBoundingClientRect().height);
      const root = document.documentElement.style;
      root.setProperty('--koopbalk-h', `${balkHoogte ? balkHoogte + 12 : 0}px`);
      const chatHoogte = chat ? chat.getBoundingClientRect().height : 0;
      root.setProperty('--koopbalk-chat', `${balkHoogte ? Math.round((balkHoogte - chatHoogte) / 2) : 0}px`);
    }).observe(balk);

    // De balk laat rechts plaats voor de chatknop. Is die van de pagina
    // gehaald (theme editor), dan loopt de balk door tot de rand.
    if (!chat) balk.dataset.zonderChat = '';

    // De eerste productfoto houdt vanaf het begin ruimte vrij voor de balk
    // (--koopbalk-ruimte), ook als die nog verborgen is. Anders valt de
    // onderkant van de foto achter de balk, of verspringt de foto zodra de
    // balk verschijnt. Verborgen heeft de balk geen hoogte, dus even tonen,
    // meten en terugzetten — binnen één frame, dus onzichtbaar. Gemeten vanaf
    // de bovenkant van de balk, dus inclusief de afstand tot de schermrand.
    const meetRuimte = () => {
      const verborgen = balk.hidden;
      balk.hidden = false;
      const hoogte = Math.round(innerHeight - balk.getBoundingClientRect().top);
      balk.hidden = verborgen;
      document.documentElement.style.setProperty('--koopbalk-ruimte', `${hoogte}px`);
    };
    meetRuimte();
    let wacht;
    window.addEventListener('resize', () => {
      cancelAnimationFrame(wacht);
      wacht = requestAnimationFrame(meetRuimte);
    });

    const gekozen = document.querySelector('[data-gekozen-variant]');
    const varianten = document.querySelector('variant-selects');
    if (gekozen && varianten) {
      // De gekozen optie(s) achter elkaar, zoals Shopify de varianttitel toont.
      const toon = () => {
        const waarden = [...varianten.querySelectorAll('fieldset input:checked, select option[selected]')].map(
          (el) => el.value
        );
        if (waarden.length) gekozen.textContent = waarden.join(' / ');
      };
      varianten.addEventListener('change', () => requestAnimationFrame(toon));
      toon();
    }

    // Beschikbaar: het eigen label (kort op de telefoon, voluit daarboven).
    // Niet beschikbaar: de tekst van de gewone knop, zoals "Uitverkocht".
    const eigenLabel = knop.innerHTML;
    const bijwerken = () => {
      if (echteKnop) {
        knop.disabled = echteKnop.disabled;
        if (echteKnop.disabled) knop.textContent = echteKnop.textContent.trim();
        else knop.innerHTML = eigenLabel;
      }
    };
    bijwerken();

    const kijker = new MutationObserver(bijwerken);
    if (echteKnop) kijker.observe(echteKnop, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
  }


  /* --------------------------------------------- prijs met installatie

     Heeft de bezoeker een installatie samengesteld of extra's aangevinkt, dan
     tonen de koopkaart en de meelopende balk het totaal: laadpaal plus
     installatie plus extra's. De winkelwagen krijgt die regels via
     dienstenMeenemen.

     Het basisbedrag komt uit data-basisprijs, niet uit de zichtbare tekst: die
     tekst is na de eerste keer al het totaal. Dawn vervangt bij een
     variantwissel de inhoud van het prijsblok; de MutationObserver zet daarna
     het totaal terug. Schrijven gebeurt alleen bij een verschil, zodat de
     observer zichzelf niet eindeloos aanroept. */

  function prijsMetInstallatie() {
    const blok = document.querySelector('product-info [id^="price-"]');
    const installatie = document.querySelector('flux-installatie');
    if (!blok || (!installatie && !document.querySelector('[data-extras]'))) return;

    const overzicht = document.querySelector('[data-bestelling]');
    const kopVariant = document.querySelector('[data-kop-variant]');
    const balkPrijs = document.querySelector('[data-sticky-prijs]');
    const balkBtw = document.querySelector('[data-sticky-btw]');
    const formaat = blok.dataset.geldformaat;

    const zet = (el, tekst) => {
      if (el && el.textContent !== tekst) el.textContent = tekst;
    };

    const teken = () => {
      const hoofd = blok.querySelector('[data-basisprijs]');
      if (!hoofd) return;

      // Voor het element is opgewaardeerd bestaat de getter nog niet: dan 0.
      const inst = Number(installatie?.installatieBedrag) || 0;
      const extras = extrasBedrag();
      const extra = inst + extras;
      const basis = Number(hoofd.dataset.basisprijs);
      const totaal = geld(basis + extra, formaat);

      zet(hoofd, totaal);
      zet(balkPrijs, totaal);

      const oud = blok.querySelector('[data-vergelijkprijs]');
      if (oud) zet(oud, geld(Number(oud.dataset.vergelijkprijs) + extra, formaat));

      if (overzicht) tekenOverzicht(basis);
      // "incl. btw", "incl. btw & installatie", "incl. btw & extra's" of
      // "incl. btw, installatie & extra's": wat er in het getoonde bedrag zit.
      if (balkBtw) {
        const d = balkBtw.dataset;
        zet(balkBtw, inst > 0 && extras > 0 ? d.tBeide : inst > 0 ? d.tInstallatie : extras > 0 ? d.tExtras : d.tBtw);
      }
    };

    /* Elke regel die in de winkelwagen komt, bij naam: de laadpaal met zijn
       uitvoering, de installatie (meerwerk ingesprongen eronder) en elk
       aangevinkt product uit "Vaak samen gekocht". Opgebouwd met
       textContent, want namen komen uit de winkel. */
    const tekenOverzicht = (basis) => {
      const variant = document.querySelector('[data-gekozen-variant]')?.textContent.trim();
      const regels = [
        ...(installatie?.bestelregels || []),
        ...[...document.querySelectorAll(AANGEVINKT)].map((v) => ({
          naam: v.closest('label').querySelector('[data-extra-naam]').textContent.trim(),
          bedrag: Number(v.dataset.prijs),
        })),
      ];

      overzicht.hidden = regels.length === 0;
      if (kopVariant) kopVariant.hidden = regels.length > 0;
      if (!regels.length) return;

      const regel = ({ naam, sub, bedrag, uitvoering }) => {
        const li = document.createElement('li');
        li.className = `flex items-baseline justify-between gap-4${sub ? ' ps-3 text-muted-foreground' : ' text-foreground'}`;
        const links = li.appendChild(document.createElement('span'));
        links.className = 'min-w-0';
        links.appendChild(document.createElement('span')).textContent = naam;
        links.lastChild.className = 'block';
        if (uitvoering) {
          const u = links.appendChild(document.createElement('span'));
          u.className = 'block text-xs text-muted-foreground';
          u.textContent = uitvoering;
        }
        const rechts = li.appendChild(document.createElement('span'));
        rechts.className = 'shrink-0 tabular-nums';
        rechts.textContent = bedrag === null ? overzicht.dataset.tVolgt : geld(bedrag, formaat);
        return li;
      };

      const lijst = overzicht.querySelector('[data-bestelregels]');
      const nieuw = [{ naam: overzicht.dataset.productTitel, uitvoering: variant, bedrag: basis }, ...regels].map(regel);
      // Alleen vervangen als er iets veranderd is: de MutationObserver op het
      // prijsblok roept dit vaak aan.
      const html = nieuw.map((li) => li.outerHTML).join('');
      if (lijst.innerHTML !== html) lijst.replaceChildren(...nieuw);
    };

    teken();
    document.addEventListener('flux:installatie', teken);
    document.addEventListener('flux:extras', teken);
    new MutationObserver(teken).observe(blok, { childList: true, subtree: true, characterData: true });
  }

  /* Ook voor de installatiehulp: die toont bedragen in dezelfde kaart, en twee
     notaties naast elkaar ("€ 839,00" en "€839,00") ogen slordig. */
  window.fluxGeld = (centen) => geld(centen, document.querySelector('[data-geldformaat]')?.dataset.geldformaat);

  /* Bedrag in centen, opgemaakt volgens het geldformaat van de winkel, zodat
     het totaal er precies zo uitziet als wat Shopify zelf met | money toont. */
  function geld(centen, formaat = '€{{amount_with_comma_separator}}') {
    const bedrag = (decimalen, duizend, komma) => {
      const [heel, rest] = (centen / 100).toFixed(decimalen).split('.');
      return heel.replace(/\B(?=(\d{3})+(?!\d))/g, duizend) + (rest ? komma + rest : '');
    };
    const soorten = {
      amount: () => bedrag(2, ',', '.'),
      amount_no_decimals: () => bedrag(0, ',', '.'),
      amount_with_comma_separator: () => bedrag(2, '.', ','),
      amount_no_decimals_with_comma_separator: () => bedrag(0, '.', ','),
      amount_with_space_separator: () => bedrag(2, ' ', ','),
      amount_with_period_and_space_separator: () => bedrag(2, ' ', '.'),
      amount_with_apostrophe_separator: () => bedrag(2, "'", '.'),
    };
    return formaat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, soort) => (soorten[soort] || soorten.amount_with_comma_separator)());
  }


  /* ------------------------------------------------- diensten meenemen

     Dawn legt bij 'Aan winkelwagen toevoegen' één variant in de winkelwagen.
     Heeft de bezoeker installatie samengesteld of een servicecontract
     aangevinkt, dan moeten die regels mee. Daarom onderscheppen we het
     formulier in de capture-fase, leggen we alles in één keer neer via
     /cart/add.js, en laten we Dawn's eigen afhandeling los.

     Mislukt dat, dan geven we het formulier alsnog aan Dawn terug: liever een
     laadpaal zonder installatie in de winkelwagen dan een bezoeker die niets
     kan bestellen. */

  /* --------------------------------------------- kabels en extra's

     Rijen uit snippets/flux-product-extras: het blok "Kabels" bij de
     uitvoeringskeuze en "Vaak samen gekocht" onder de installatie. Elke rij
     heeft een reden (data-toon) en is alleen zichtbaar zolang die geldt:
     - socket / zonder-kabel: de gekozen variant (data-varianten-soort koppelt
       variant-id aan socket, zonder-kabel of kabel);
     - paal: de installatiehulp gaf "op een eigen paal" en stuurt de paal niet
       zelf al mee;
     - altijd: algemene accessoires.
     Een rij die verdwijnt, gaat ook uit: anders koop je een kabel voor een
     uitvoering die je niet meer hebt. Van één accessoire (data-groep) kies je
     één variant. */

  /* Ook FluxCare telt mee: dat abonnement gaat als eigen regel de winkelwagen
     in, dus het hoort in het bedrag en in het besteloverzicht te staan. */
  const AANGEVINKT = '[data-extra-vink]:checked, [data-servicecontract]:checked';

  function extrasBedrag() {
    return [...document.querySelectorAll(AANGEVINKT)].reduce((som, v) => som + Number(v.dataset.prijs), 0);
  }

  function vaakSamenGekocht() {
    const blokken = [...document.querySelectorAll('[data-extras]')];
    const form = document.querySelector('product-info form[data-type="add-to-cart-form"]');
    if (!blokken.length || !form) return;

    const soorten = Object.fromEntries(
      blokken[0].dataset.variantenSoort
        .split(',')
        .filter(Boolean)
        .map((paar) => paar.split(':'))
    );
    const rijen = [...document.querySelectorAll('[data-extra]')];
    const meld = () => blokken[0].dispatchEvent(new CustomEvent('flux:extras', { bubbles: true }));

    const tonen = () => {
      const soort = soorten[form.querySelector('[name="id"]')?.value];
      const hulp = document.querySelector('flux-installatie');
      // De paal alleen aanbieden als de installatiehulp hem niet al meestuurt.
      const paalNodig = hulp?.plek === 'paal' && !hulp?.paalMeegenomen;
      let uitgezet = false;
      for (const rij of rijen) {
        const reden = rij.dataset.toon;
        // Een rij kan meer dan één reden hebben ("socket zonder-kabel").
        const toon = reden === 'altijd' ? true : reden === 'paal' ? paalNodig : reden.split(' ').includes(soort);
        rij.hidden = !toon;
        const vink = rij.querySelector('[data-extra-vink]');
        if (!toon && vink.checked) {
          vink.checked = false;
          uitgezet = true;
        }
      }
      for (const blok of blokken) {
        blok.hidden = [...blok.querySelectorAll('[data-extra]')].every((r) => r.hidden);
      }

      /* De kabelversie komt zonder kabel van de fabrikant. Zolang er geen kabel
         is aangevinkt, staat die regel erbij; kiest iemand er een, dan is de
         waarschuwing overbodig en verdwijnt hij. */
      const kabelHint = document.querySelector('[data-kabel-nodig]');
      if (kabelHint) {
        const kabelGekozen = rijen.some((rij) => !rij.hidden && rij.querySelector('[data-extra-vink]')?.checked);
        kabelHint.hidden = !(soort === 'zonder-kabel' && !kabelGekozen);
      }

      if (uitgezet) meld();
    };

    document.addEventListener('change', (e) => {
      /* FluxCare heeft geen zichtbaarheidsregels, maar wel één regel: je kiest
         er één. Basis en Plus verschillen alleen in reactietijd, dus allebei
         aanvinken zou betekenen dat je twee keer betaalt voor dezelfde dekking.
         Vandaar hetzelfde gedrag als bij een variantgroep: de nieuwe keuze
         vervangt de vorige. */
      const service = e.target.closest('[data-servicecontract]');
      if (service) {
        if (service.checked) {
          document.querySelectorAll('[data-servicecontract]').forEach((v) => {
            if (v !== service) v.checked = false;
          });
        }
        meld();
        return;
      }
      const vink = e.target.closest('[data-extra-vink]');
      if (!vink) return;
      if (vink.checked) {
        document.querySelectorAll(`[data-extra-vink][data-groep="${vink.dataset.groep}"]`).forEach((v) => {
          if (v !== vink) v.checked = false;
        });
      }
      meld();
      tonen();
    });

    // Dawn zet het variant-id in het formulier na een wissel; pubsub meldt het.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(tonen));
    }
    document.addEventListener('flux:installatie', tonen);
    tonen();
  }

  function dienstenMeenemen() {
    const info = document.querySelector('product-info');
    const form = info?.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener(
      'submit',
      async (e) => {
        const hulp = document.querySelector('flux-installatie');
        const contracten = [...document.querySelectorAll('[data-servicecontract]:checked')];
        const extras = [...document.querySelectorAll('[data-extra-vink]:checked')];
        // De installatie bestaat uit meerdere regels (pakket plus meerwerk),
        // maar hoort bij elkaar. Ze krijgen dezelfde sleutel mee, zodat de
        // winkelwagen ze als één regel "Installatie" toont en de klant ze niet
        // per stuk kan wijzigen (snippets/flux-cart-installatie).
        const set = `i${Date.now().toString(36)}`;
        // De montagepaal (apart) is een gewoon product en blijft een eigen
        // regel; de rest van de installatie hoort bij elkaar.
        const vanHulp = hulp?.regelsVoorWinkelwagen || [];
        const installatie = vanHulp
          .filter((r) => !r.apart)
          .map((r) => ({ id: r.id, quantity: r.quantity, properties: { _installatie: set, _deel: 'installatie' } }));
        const losseProducten = vanHulp.filter((r) => r.apart).map((r) => ({ id: r.id, quantity: r.quantity }));
        const extra = [
          ...installatie,
          ...losseProducten,
          ...[...contracten, ...extras].map((c) => ({ id: Number(c.value), quantity: 1 })),
        ];
        if (!extra.length) return; // niets extra's: Dawn doet zijn werk

        e.preventDefault();
        e.stopImmediatePropagation();

        const variant = form.querySelector('[name="id"]')?.value;
        const knop = form.querySelector('[type="submit"]');
        const toelichting = hulp?.toelichtingVoorWinkelwagen;
        knop?.setAttribute('aria-busy', 'true');

        // De laadpaal draagt dezelfde sleutel, zodat de installatieregel er in
        // de winkelwagen direct onder staat. De notitie begint met een
        // liggend streepje: hij hoort op de bestelling, niet in beeld bij de
        // klant — daar staat de installatie al uitgeschreven.
        const eigenschappen = installatie.length ? { _installatie: set } : undefined;
        if (eigenschappen && toelichting) eigenschappen._Installatie = toelichting;
        const regels = [{ id: Number(variant), quantity: 1, properties: eigenschappen }, ...extra];

        // Dawn's winkelwagenlade wil de secties mee in hetzelfde verzoek,
        // net zoals product-form.js dat doet. Anders staat de lade leeg.
        const lade = document.querySelector('cart-drawer');
        const secties = lade?.getSectionsToRender?.().map((s) => s.id);

        try {
          const antwoord = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: regels,
              sections: secties,
              sections_url: window.location.pathname,
            }),
          });
          if (!antwoord.ok) throw new Error(antwoord.status);
          const uitkomst = await antwoord.json();

          if (lade && typeof lade.renderContents === 'function' && uitkomst.sections) {
            // Dawn laat 'is-empty' op de lade staan als de winkelwagen leeg wás;
            // daarna zoekt hij bij het openen naar een leeg-blok dat er niet
            // meer is en valt zijn focusbeheer om.
            lade.classList.remove('is-empty');
            lade.renderContents(uitkomst);
          } else {
            window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
          }
        } catch {
          form.submit(); // gewone verzending als terugval
        } finally {
          knop?.removeAttribute('aria-busy');
        }
      },
      { capture: true }
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dienstenMeenemen);
  else dienstenMeenemen();

  /* De prijs bij de titel volgt de gekozen uitvoering. Dawn zet na een
     variantwissel een nieuw prijsblok neer; het basisbedrag staat daar in
     data-basisprijs (de zichtbare tekst is soms al het totaal). */
  function kopPrijs() {
    const doel = document.querySelector('[data-kop-bedrag]');
    const blok = document.querySelector('product-info [id^="price-"]');
    if (!doel || !blok) return;
    const vergelijk = document.querySelector('[data-kop-vergelijk]');
    const teken = () => {
      const basis = blok.querySelector('[data-basisprijs]');
      if (!basis) return;
      const tekst = geld(Number(basis.dataset.basisprijs), blok.dataset.geldformaat);
      if (doel.textContent !== tekst) doel.textContent = tekst;
      if (vergelijk) {
        const oud = blok.querySelector('[data-vergelijkprijs]');
        vergelijk.hidden = !oud;
        if (oud) {
          const t = geld(Number(oud.dataset.vergelijkprijs), blok.dataset.geldformaat);
          if (vergelijk.textContent !== t) vergelijk.textContent = t;
        }
      }
    };
    teken();
    new MutationObserver(teken).observe(blok, { childList: true, subtree: true });
  }

  const start = () => {
    stickyKoopbalk();
    kopPrijs();
    vaakSamenGekocht();
    prijsMetInstallatie();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  class FluxGalerij extends HTMLElement {
    connectedCallback() {
      this.hoofd = this.querySelector('[data-galerij-hoofd]');
      if (!this.hoofd) return;

      // De verborgen lijst is de bron: hij staat in de volgorde van
      // product.media en verandert niet. De grote foto is een kopie van de
      // regel waar we nu zijn, zodat bladeren geen elementen verplaatst.
      this.tegels = [...this.querySelectorAll('[data-galerij-tegel] img')];
      this.vorige = this.querySelector('[data-galerij-vorige]');
      this.volgende = this.querySelector('[data-galerij-volgende]');

      this.index = Math.max(
        0,
        this.tegels.findIndex((img) => img.closest('[data-galerij-tegel]').dataset.mediaId === this.hoofd.dataset.mediaId)
      );
      this.#pijlen();

      this.vorige?.addEventListener('click', () => this.#toon(this.index - 1));
      this.volgende?.addEventListener('click', () => this.#toon(this.index + 1));

      // Dawn meldt een variantwissel via pubsub (assets/pubsub.js).
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.afmelden = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const id = data?.variant?.featured_media?.id;
        if (!id) return;
        const i = this.tegels.findIndex((img) => img.closest('[data-galerij-tegel]').dataset.mediaId === String(id));
        if (i >= 0) this.#toon(i);
      });
    }

    disconnectedCallback() {
      this.afmelden?.();
    }

    /* Een pijl staat er alleen als er aan die kant nog een foto is. */
    #pijlen() {
      if (this.vorige) this.vorige.hidden = this.index <= 0;
      if (this.volgende) this.volgende.hidden = this.index >= this.tegels.length - 1;
    }

    #toon(i) {
      if (i < 0 || i >= this.tegels.length || i === this.index) return;
      const bron = this.tegels[i];

      for (const attr of ['src', 'srcset', 'alt', 'width', 'height']) {
        const waarde = bron.getAttribute(attr);
        waarde === null ? this.hoofd.removeAttribute(attr) : this.hoofd.setAttribute(attr, waarde);
      }
      // sizes blijft van de grote foto: die is breder dan de bron in de lijst.
      this.hoofd.dataset.mediaId = bron.closest('[data-galerij-tegel]').dataset.mediaId;
      this.index = i;
      this.#pijlen();
    }
  }

  if (!customElements.get('flux-galerij')) customElements.define('flux-galerij', FluxGalerij);
})();
